import {Component, ElementRef, EventEmitter, Input, Output, ViewChild} from '@angular/core'
import {ButtonModel} from '../../../../../../../ui/button-group/button-group.component';
import {ParametryZbioruUszkodzenPrzedmiotow, ZbiorUszkodzenPrzedmiotow} from '../../../../../../../../store/zbior-uszkodzen-przedmioty/zbiorUszkodzenPrzedmiotow';
import {Observable} from 'rxjs';
import {ZbiorUszkodzen} from '../../../../../../../../store/zbior-uszkodzen/zbiorUszkodzen';
import {selectZbiorUszkodzenById} from '../../../../../../../../store/zbior-uszkodzen/zbiorUszkodzen.selectors';
import {Store} from '@ngrx/store';
import {TypPrzedmiotuUbezpieczenia} from '../../../../../../../../model/przedmioty/typPrzedmiotuUbezpieczenia';
import {NavigationService} from '../../../../../../../../services/navigation/navigation.service';
import {SlownikUszkodzen} from "../../../../../../../../model/uszkodzenia/slownik-uszkodzen";
import {take} from "rxjs/operators";

@Component({
  selector: 'shared-lista-uszkodzen',
  templateUrl: './lista-uszkodzen.component.html',
  styleUrls: ['lista-uszkodzen.component.scss']
})
export class ListaUszkodzenComponent {

  @ViewChild('buttonElement') buttonElement!: ElementRef;

  @Input()
  daneZgloszenia: any = '';

  @Input()
  przedmiot: ButtonModel = {};

  @Input()
  daneKlienta = null;

  @Input()
  czyPrzedmiotZeZgloszenia!: boolean;

  @Input()
  czyPoprawnaWalidacja: boolean = true;

  @Input()
  czyDostepnyTylkoJedenPrzedmiot = false;

  @Input()
  czyDodaneDodatkowePrace = false;

  @Input()
  zbiorUszkodzenPrzedmiotu!: ZbiorUszkodzenPrzedmiotow<ParametryZbioruUszkodzenPrzedmiotow>

  @Output()
  usunZbiorUszkodzenClick = new EventEmitter()

  @Output()
  usunUszkodzenieClick = new EventEmitter()

  @Output()
  wybranoPrzedmiotUbezpieczenia = new EventEmitter();
  
  @Input()
  czyWyswietlicSeparator = false;

  constructor(private store: Store, private navigationService: NavigationService) {}

  pobierzZbiorUszkodzen(zbiorUszkodzenId: string): Observable<ZbiorUszkodzen | undefined> {
    return this.store.select(selectZbiorUszkodzenById, zbiorUszkodzenId);
  }

  usunZbiorUszkodzen($event: any): void {
    this.usunZbiorUszkodzenClick.emit($event)
  }

  usunUszkodzenie($event: any): void {
    this.usunUszkodzenieClick.emit($event)
  }

  wybierzPrzedmiotUbezpieczenia($event: any): void {
    this.wybranoPrzedmiotUbezpieczenia.emit($event)
  }

  czyMoznaDodacKolejneUszkodzenie(): boolean {
    return this.przedmiot.name !== TypPrzedmiotuUbezpieczenia.INNE.nazwa &&
         !(this.przedmiot.name === TypPrzedmiotuUbezpieczenia.MEBLE.nazwa || this.przedmiot.name === TypPrzedmiotuUbezpieczenia.SPRZET_AGD_RTV.nazwa) &&
         !(this.przedmiot.name === TypPrzedmiotuUbezpieczenia.PRZEDMIOTY_SZKLANE.nazwa && this.zbiorUszkodzenPrzedmiotu) &&
         !(this.przedmiot.name === TypPrzedmiotuUbezpieczenia.OSZKLENIA_WITRAZE.nazwa && this.zbiorUszkodzenPrzedmiotu)
  }

  czyDodaneUszkodzenia(): boolean {
    return !!this.zbiorUszkodzenPrzedmiotu && this.zbiorUszkodzenPrzedmiotu.zbiorUszkodzenIds.length > 0
  }

  czyPrzedmiotZUszkodzeniem(): boolean {
    return !(this.przedmiot.name === TypPrzedmiotuUbezpieczenia.MEBLE.nazwa || this.przedmiot.name === TypPrzedmiotuUbezpieczenia.SPRZET_AGD_RTV.nazwa)
  }

  czyPrzedmiotInne(): boolean {
    return this.przedmiot.name === TypPrzedmiotuUbezpieczenia.INNE.nazwa
  }

  sprawdzCzyPoprawnaWalidacja(): boolean {
    const czyPoprawnaWalidacja = this.czyMoznaDodacKolejneUszkodzenie() && !this.czyPoprawnaWalidacja;
    if (czyPoprawnaWalidacja) {
      this.buttonElement?.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    return czyPoprawnaWalidacja;
  }

  dodajDodatkowePrace(): void {
    this.navigationService.navigateWithExtras(['/procesUszkodzen/przedmiotUbezpieczenia/dodatkowePrace'], {queryParams: {idPrzedmiotu: this.przedmiot.id}})
  }

  pobierzPosortowaneDodaneUszkodzenia(): string[] {
    if (!this.zbiorUszkodzenPrzedmiotu) return [];

    const ids = [...this.zbiorUszkodzenPrzedmiotu.zbiorUszkodzenIds];
    const dodatkowePraceId: string[] = [];
    const pozostaleUszkodzenia: string[] = [];

    ids.forEach(id => {
      this.store.select(selectZbiorUszkodzenById, id).pipe(take(1)).subscribe(zbior => {
        if (SlownikUszkodzen.DODATKOWE_PRACE.nazwa === zbior?.lokalizacja) {
          dodatkowePraceId.push(id);
        } else {
          pozostaleUszkodzenia.push(id);
        }
      });
    });

    return [...pozostaleUszkodzenia, ...dodatkowePraceId];
  }
}
